import { NgModule } from '@angular/core';
import { DashboardCardHeaderComponent } from './components/dashboard-card-header/dashboard-card-header.component';
import { BaseSharedModule } from '../../shared/base-shared.module';
import { AppsSharedModule } from '../../apps-shared/apps-shared.module';

@NgModule({
  imports: [BaseSharedModule, AppsSharedModule],
  declarations: [DashboardCardHeaderComponent],
  exports: [DashboardCardHeaderComponent],
})
export class BaseDashboardModule {}
